module.exports = __webpack_public_path__ + "img/ta.da683a29.png";